import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    hook: {
      insert: (node) => this.helpers.onInsertStickyPlaceholder(node)
    }
  });
}
